<template>
    <Dialog 
          :header="'Tạo mới thông tin khách hàng'"
          :visible.sync="displayDialog"
          :style="{width: '60vw'}"
          :class="'popup-dialog-customer'"
          :modal="true"
        ><!--:contentStyle="{overflow: 'visible'}"-->
        <div class="p-fluid">
          <div class="p-col-12 form-popup-custom-customer">
            <div class="p-grid">
              <div class="p-col-6 box-left">
                <div class="p-field box_group_item">
                  <div class="p-field">
                    <label>Tên khách hàng<span class="error">*</span></label>
                  </div>
                  <div class="p-field">
                    <InputText id="full_name" autocomplete="off" type="text" v-model="objectData.full_name" />
                    <small v-if="validationErrors && validationErrors['full_name']"
                           class="p-invalid" >{{validationErrors['full_name']}}</small>
                  </div>
                </div>
                <div class="p-field box_group_item">
                  <div class="p-field">
                    <label>Số điện thoại<span class="error">*</span></label>
                  </div>
                  <div class="p-field">
                    <InputText id="phone_number" autocomplete="off" type="text" v-model="objectData.phone_number"/>
                    <small v-if="validationErrors && validationErrors['phone_number']"
                           class="p-invalid" >{{validationErrors['phone_number']}}</small>
                  </div>
                </div>
                <div class="p-field box_group_item">
                  <div class="p-field">
                    <label>Email</label>
                  </div>
                  <div class="p-field">
                    <InputText  id="email" type="text" autocomplete="off" v-model="objectData.email"/>
                    <small v-if="validationErrors && validationErrors['email']"
                           class="p-invalid" >{{validationErrors['email']}}</small>
                  </div>
                </div>
                <div class="p-field box_group_item">
                  <div class="p-field">
                    <label>Ngày sinh</label>
                  </div>
                  <div class="p-field">
                    <Calendar @input="changeInput" id="icon" v-model="objectData.birthday" :showIcon="true"/>
                  </div>
                </div>
                <div class="p-field box_group_item">
                  <div class="p-field">
                    <label>Nhóm khách hàng<span class="error">*</span></label>
                  </div>
                  <div class="p-field">
                    <Dropdown  placeholder="Chọn nhóm khách hàng" inputId="customer_type" v-model="objectData.customer_type" :options="customerType" optionLabel="label"  optionValue="value" />
                    <small v-if="validationErrors && validationErrors['customer_type']"
                           class="p-invalid" >{{validationErrors['customer_type']}}</small>
                  </div>
                </div>
              </div>
              <div class="p-col-6 box-right">
                <div class="p-field box_group_item">
                  <div class="p-field">
                    <label>Tỉnh/Thành phố</label>
                  </div>
                  <div class="p-field">
                    <v-select :filterable="false" placeholder="Chọn tỉnh/thành phố" v-model="objectData.province_id"  :options="list_province" :reduce="province => province.id"  label="name" @search="fetchOptionsProvince" @input="changeProvince">
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                    </v-select>
                    <!--<Dropdown @change="changeProvince($event)" class="width-300" :filter="true" v-model="objectData.province_id" :options="list_province" optionLabel="name" optionValue="id" placeholder="Chọn tỉnh/thành phố"/>
                 --> </div>
                </div>
                <div class="p-field box_group_item">
                  <div class="p-field">
                    <label>Quận/Huyện</label>
                  </div>
                  <div class="p-field">
                    <v-select :filterable="false" placeholder="Chọn quận/huyện" v-model="objectData.district_id"  :options="list_district" :reduce="districts => districts.id"  label="name" @search="fetchOptionsDistrict" @input="changeDistrict">
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                    </v-select>
                    <!--<Dropdown @change="changeDistrict($event)" class="width-300" :filter="true" v-model="objectData.district_id" :options="list_district" optionLabel="name" optionValue="id" placeholder="Chọn quận/huyện"/>
                -->  </div>
                </div>
                <div class="p-field box_group_item">
                  <div class="p-field">
                    <label>Phường/Xã</label>
                  </div>
                  <div class="p-field">
                    <v-select :filterable="false" placeholder="Chọn phường/xã" v-model="objectData.ward_id"  :options="list_ward" :reduce="wards => wards.id"  label="name" @search="fetchOptionsWard" >
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                    </v-select>
                   <!-- <Dropdown class="width-300" :filter="true" v-model="objectData.ward_id" :options="list_ward"  optionLabel="name" optionValue="id" placeholder="Chọn phường/xã"/>
                  --></div>
                </div>
                <div class="p-field box_group_item">
                  <div class="p-field">
                    <label>Số nhà</label>
                  </div>
                  <div class="p-field">
                    <InputText  id="address" type="text" v-model="objectData.address"/>
                  </div>
                </div>
                <div class="p-field box_group_item">
                  <div class="p-field">
                    <label>Trạng thái tài khoản<span class="error">*</span></label>
                  </div>
                  <div class="p-field">
                    <Dropdown  inputId="status" v-model="objectData.status" :options="optionStatus" optionLabel="label"  optionValue="value" />
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        <template #footer>
            <Button :disabled="submitForm" class="p-button-success" :label="formMode == 'edit' ? 'Lưu' : 'Tạo'" @click="saveData" />
        </template>
      </Dialog>
</template>

<script>
import DataServices from '@/core/DataServices'
import moment from "moment";

export default {
  props: {
    show: Boolean,
    mode: String,
    modelName: String,
    model: Object,
    screen: String,
    module: String,
    dataDefault:Object
  },
  data() {
    return {
        name: '',
        status: true,
        parent_id: 0,
        is_management: true,
        displayDialog: this.show,
        validationErrors: {},
        name_exists: false,
        optionsParent: [],
        submitForm: false,
        levelParentIndex: 0,
        description: '',
        list_unit:[],
        customerType: [{value: 1, label: 'Cá nhân'}, {value: 2, label: "Doanh nghiệp"}],
        list_province:[],
        list_district:[],
        list_ward:[],
        optionStatus: [{value: 0, label: 'Ngưng hoạt động'}, {value: 1, label: 'Đang hoạt động'} ],
        objectData: {
          full_name: '',
          phone_number: '',
          email: '',
          birthday: '',
          customer_type: 1,
          province_id: null,
          district_id: null,
          ward_id: null,
          address: '',
          status: 1
        }
    }
  },
  async created() {
    this.formMode = this.mode;
    var vm = this;
    //load danh sách tỉnh/tp
    this.$coreService.getAllProvince().then(async (dataProvince) => {
      vm.list_province = dataProvince;
    }).catch(async () => {
      vm.list_province = [];
    });
    //load default sdt
    if (!this.$myConstants.isEmpty(this.dataDefault)){
      this.objectData.phone_number = (!this.$myConstants.isEmpty(this.dataDefault.phone)) ? this.dataDefault.phone:'';
    }


  },
  methods: {
    async checkPhoneNumber() {
      this.objectData.phone_number = this.objectData.phone_number.trim();
      var phone_number = this.objectData.phone_number
      if (phone_number !== "") {
        var phone_convert = phone_number;
        phone_convert = this.$myConstants.replaceAt(phone_number, 0, '+84');
        var where = { phone_number: {'_ilike': phone_convert} }
        if (this.modelData != null) where = Object.assign(where, {user_id: {'_neq': this.modelData.user_id}})
        var data = await DataServices.getList('users', {"fields": "id", "variables": JSON.stringify({where_key: where})});
        return data && data[Object.keys(data)].length > 0
      }
    },
    changeDistrict() {
      var vm = this;
      if (!this.$myConstants.isEmpty(this.objectData.district_id)){
        this.$coreService.getWardByIdDistrict(this.objectData.district_id).then(async (data) => {
          vm.list_ward = data;
        }).catch(async () => {
          vm.list_ward = [];
        });
        this.objectData.ward_id = null;
      }
    },
    async fetchOptionsWard (search, loading) {
      //console.log("searchsearch:",search);
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var whereAttact = {plain_name:{_like: "%"+this.$myConstants.SkipVN(search).trim()+"%"}};
        this.list_ward =await this.$coreService.getWardByIdDistrict(this.objectData.district_id,whereAttact);
      }else {
        this.list_ward =await this.$coreService.getWardByIdDistrict(this.objectData.district_id);
      }
    },
    async fetchOptionsDistrict (search, loading) {
      //console.log("searchsearch:",search);
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var whereAttact = {plain_name:{_like: "%"+this.$myConstants.SkipVN(search).trim()+"%"}};
        this.list_district =await this.$coreService.getDistrictByIdProvince(this.objectData.province_id,whereAttact);
      }else {
        this.list_district =await this.$coreService.getDistrictByIdProvince(this.objectData.province_id);
      }
    },
    async fetchOptionsProvince (search, loading) {
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var whereAttact = {plain_name:{_like: "%"+this.$myConstants.SkipVN(search).trim()+"%"}};
        this.list_province =await this.$coreService.getAllProvince(whereAttact);
      }else {
        this.list_province =await this.$coreService.getAllProvince();
      }
    },
    changeProvince() {
      var vm = this;
      if (!this.$myConstants.isEmpty(this.objectData.province_id)){
        this.$coreService.getDistrictByIdProvince(this.objectData.province_id).then(async (data) => {
          vm.list_district = data;
        }).catch(async () => {
          vm.list_district = [];
        });
      }
      //set ward về []
      this.list_ward = [];
      this.objectData.district_id = null;
      this.objectData.ward_id = null;
    },
    changeInput($event) {
      var date = new Date($event);
      this.objectData.birthday = moment(date).format('DD/MM/YYYY');
    },
    async getCodeNext() {
      var data =await DataServices.getObjectData('service_supplies',{},{id: 'desc'});
      if (!this.$myConstants.isEmpty(data)){
        var codeLast = data.code;
        var codeRightLast = codeLast.substring((codeLast.length - 6));//Cắt lấy 6 ký tự cuối cùng
        var codeRightTmp =(parseInt(codeRightLast) + 1).toString();
        return 'VT'+codeRightTmp.padStart(6, '0');
      }
      return 'VT000001';
    },
    async validateData() {
      this.validationErrors = {};
      if (this.$myConstants.isEmpty(this.objectData.full_name)){
        this.validationErrors['full_name'] = 'Nhập tên khách hàng';
      }
      if (this.objectData.phone_number == '' || this.objectData.phone_number.length == 0){
        this.validationErrors['phone_number'] = 'Nhập số điện thoại';
      }else {
        if (!this.$myConstants.validatePhone(this.objectData.phone_number,10)){
          this.validationErrors['phone_number'] = 'Không đúng định dạng số điện thoại di động, vui lòng nhập lại.';
        }else {
          //this.phone_exists = await this.checkPhoneNumber();
          //console.log("this.checkPhoneNumber():",await this.checkPhoneNumber())
          if (await this.checkPhoneNumber()){
            this.validationErrors['phone_number'] = 'Số điện thoại trùng với tài khoản khác';
          }
        }
      }
      //if (this.phone_number != '' && (this.phone_number.length != 10 || isNaN(this.phone_number))) this.validationErrors['phone_number'] = 'Nhập số điện thoại không đúng định dạng';
      if(this.objectData.customer_type  == undefined || this.objectData.customer_type  == 0) this.validationErrors['customer_type'] = 'Chọn nhóm khách hàng';
      if (!(Object.entries(this.validationErrors).length === 0)) {
        //Nếu tồn tại lỗi thì force để load validator mượt
        this.$forceUpdate();
      }
    },
    async saveData() {
      var vm = this;
        this.submitForm = true;
        await this.validateData();
        if (Object.entries(this.validationErrors).length === 0) {
          var organization = this.$myConstants.organizationUserLogin();
          var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
          this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
          this.$store.commit('setLoading', true);
          var phone_convert = '';
          if (this.objectData.phone_number.length == 10) {
            phone_convert = this.$myConstants.replaceAt(this.objectData.phone_number, 0, '+84');
          }
          var fullname = (!this.$myConstants.isEmpty(this.objectData.full_name)) ? this.$myConstants.capitalizeFirst(this.objectData.full_name):'';
          var params = {
            'full_name':fullname ,
            'phone_number': phone_convert,
            'email': this.objectData.email,
            'address': this.objectData.address,
            'customer_type': this.objectData.customer_type,
            'country_id': 1,
            'province_id': this.objectData.province_id,
            'district_id': this.objectData.district_id,
            'ward_id': this.objectData.ward_id,
            status: 1,
            created_date:this.$myConstants.currentDate(),
            modified_date:this.$myConstants.currentDate(),
          }
          if (this.objectData.birthday != '') {
            var dateNow = new Date();
            const [d, M, y] = this.objectData.birthday.match(/\d+/g);
            var changeDate = new Date(y, M-1, d, dateNow.getHours(), dateNow.getMinutes(), dateNow.getSeconds());
            var birthdayDate = changeDate.toUTCString();
            params['birthday'] = birthdayDate;
          }
          var is_enabled = (this.objectData.status == 1) ? true:false;
          var paramsUser ={
            status: 1,
            phone_number: phone_convert,
            full_name : fullname,
            user_type: 1,
            is_enabled: is_enabled,
            creator_id:this.$store.getters.fullname.id,
            creator_organization_id:creator_organization_id,
            created_date:this.$myConstants.currentDate(),
            modified_date:this.$myConstants.currentDate(),
          };
          paramsUser.customer_profile = {data: this.$myConstants.convertJsonObject(params)};
          await DataServices.insertData('users', {"variables": JSON.stringify({objects: paramsUser})}).then(async (resData) => {
            if (!vm.$myConstants.isEmpty(resData.insert_core_user)){
              if (!vm.$myConstants.isEmpty(resData.insert_core_user.returning)){
                var dataCustomer = (!vm.$myConstants.isEmpty(resData.insert_core_user.returning[0])) ? resData.insert_core_user.returning[0]:null;
                this.$store.commit('setLoading', false);
                if (vm.screen == 'warranty_repair'){
                  var payload = {
                    module:vm.module,
                    dataCustomer:dataCustomer,
                  }
                  this.$emit('save_warranty_repair',payload);
                }else {
                  vm.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Tạo mới thành công', life: 3000 })
                  vm.displayDialog = false;
                  vm.$emit('refresh');
                }
              }
            }
          }).catch(async () => {
            vm.$toast.add({
              severity: 'error',
              summary: 'Thông báo',
              detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
              life: 3000
            });
            vm.submitForm = false;
          });
        } else this.submitForm = false;
    },
    async getLevelIndex(whereKey) {
        var variables = {
            where_key: whereKey,
            orderBy: {
                'level_parent_index': 'desc'
            },
            limit: 1
        }
        var data = await DataServices.getList(this.modelName, {"fields": "id parent_id level_parent_index", "variables": JSON.stringify(variables)});
        if (data[Object.keys(data)].length) {
            data = data[Object.keys(data)][0];
            return data;
        }
        return null;
    },
  }
}
</script>

<style lang="scss" scoped>
  .form-popup-custom-customer {
    .box-left {
      padding: 0px 30px 0px 0px
    }

    .box-right {
      padding: 0px 0px 0px 30px
    }

    .box_group_item {
      margin-bottom: 16px;
    }
  }

</style>
<style>
@media (max-width: 991px) {
  .popup-dialog-customer {
    width: 80vw !important;
  }
}
@media (max-width: 640px) {
  .popup-dialog-customer {
    width: 110vw !important;
  }
}

</style>